/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const signUpRequestPasswordMin = 12;

export const SignUpRequest = zod
	.object({
		identifier: zod.string().describe('Email address or phone number'),
		password: zod.string().min(signUpRequestPasswordMin).describe('Password')
	})
	.describe('Sign up request body');

export type SignUpRequest = zod.input<typeof SignUpRequest>;
export type SignUpRequestOutput = zod.output<typeof SignUpRequest>;
